import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
// import { withFormik } from 'formik';

import Typography from '@material-ui/core/Typography';
// import history from 'utils/history';
import ken42Logo from '../../Assets/flame-logo.png';
// import manipalLogo from '../../Assets/manipal-logo.svg';
import { makeStyles } from '@material-ui/core/styles';
import LoginImage from '../../Assets/FLAME1.jpg';
import context from '../../Utils/context';
import clsx from 'clsx';

//authentication imports
import GoogleLogin from 'react-google-login';
import { useTranslation } from 'react-i18next';
import { useHistory, withRouter } from 'react-router';
import KenSnackBar from '../../Components/KenSnackbar';
import KenInputField from '../../global_components/KenInputField';
import KenButton from '../../global_components/KenButton';
import { KEY_LOGIN_ACCESS_TOKEN, KEY_USER } from '../../Utils/constants';
import { requestForOTP, verifyOTP } from '../../Utils/apiServices';
import { CircularProgress } from '@material-ui/core';
import KenSmallLoader from '../../global_components/KenSmallLoader';
import KenIcon from '../../global_components/KenIcon';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    [theme.breakpoints.only('xs')]: {
      background: '#E5E5E5;',
    },
  },

  image: {
    backgroundImage: `url(${LoginImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light'
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.only('xs')]: {
      height: '65%',
    },
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    paddingLeft: '20%',
    paddingRight: '20%',
    [theme.breakpoints.only('xs')]: {
      paddingLeft: '10%',
      paddingRight: '10%',
    },
  },
  submit: {
    align: 'center',
    margin: theme.spacing(3, 0, 2),
  },
  overlay: {
    // position: 'relative',
    // top: '0',
    // left: '0',
    width: '100%',
    height: '100%',
    background: 'rgba(0,0,0,0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textFacultyPortal: {
    marginTop: '8px !important',
    fontSize: '28px !important',
    // lineHeight: '28px',
    textAlign: 'center',
    color: theme.palette.KenColors.neutral100,
    fontWeight: '300',
    letterSpacing: '0.14em',
  },
  signInText: {
    fontWeight: '600',
    fontSize: '28px',
    lineHeight: '28px',
    textAlign: 'center',
    color: theme.palette.KenColors.neutral900,
    letterSpacing: '0.14em',
  },
  textCenter: {
    marginTop: '250px',
  },
  fontStyleA: {
    fontWeight: '800 !important',
    fontSize: '48px !important',
    textAlign: 'center',
    color: theme.palette.KenColors.kenWhite,
    [theme.breakpoints.only('xs')]: {
      fontSize: '28px',
    },
  },
  buttonDiv: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '8px',
    marginTop: '8px',
  },
  powerBy: {
    color: theme.palette.KenColors.neutral100,
    fontSize: '10px !important',
    marginBottom: '8px !important',
  },
  hide: {
    display: 'none',
  },
  circular: {
    paddingTop: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  AbsolutePosition: {
    padding: '40px',
    [theme.breakpoints.only('xs')]: {
      position: 'absolute',
      top: '47%',
      background: theme.palette.KenColors.kenWhite,
      width: '90%',
      height: '70%',
      marginLeft: '5%',
      marginRight: '5%',
      borderRadius: '3px',
    },
  },
  logoWrap: {
    marginTop: '-16% !important',
    minHeight: '300px',
    [theme.breakpoints.down('xs')]: {
      marginTop: '0 !important',
      minHeight: 0,
    },
  },
  signInWrap: {
    margin: '0 !important',
  },
  powerByImage: {
    height: '50px',
  },
  poweredByGrid: {
    // position: 'absolute',
    // bottom: '100px',
    // [theme.breakpoints.down('sm')]: {
    //   position: 'relative',
    //   bottom: 0,
    // },
  },
  titleGrid: {
    // minHeight: '233px',
    [theme.breakpoints.down('xs')]: {
      minHeight: 0,
    },
  },
}));

function LoginPage(props) {
  const { t } = useTranslation();
  const { handleSnackbarOpen, config } = React.useContext(context);
  const history = useHistory();
  const classes = useStyles();
  const [progress, setProgress] = React.useState(false);
  //for global snackbar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [activeStep, setActiveStep] = React.useState(0);
  const [emailId, setEmailId] = React.useState(null);
  const [otp, setOtp] = React.useState(null);
  const [checkOTP, setCheckOTP] = React.useState(false);
  const [emailData, setEmailData] = React.useState(null);
  const [verifyData, setVerifyData] = React.useState(null);
  const [state, setState] = React.useState({
    seconds: 15,
    minutes: 0,
  });
  const [loading, setLoading] = useState(false);
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

  // const handleSnackbarOpen = (severity, message) => {
  //   setOpenSnackbar(true);
  //   setSnackbarSeverity(severity);
  //   setSnackbarMessage(message);
  // };

  const responseGoogle = (response) => {
    console.log('response from Google Auth', response);
    if (response?.profileObj?.email) {
      const isAuthorizedUser = config?.login?.authorizedUsers?.some(
        (el) => el.email === response.profileObj.email
      );
      if (isAuthorizedUser) {
        localStorage.setItem('loggedIn', true);
        history.push('/app/exams/examDashboard');
      } else {
        alert('Unauthorized user, Access denied!');
      }
    } else {
      // handleSnackbarOpen('error', 'Login Failed, Please try again');
    }
  };

  const handleChangeEmail = (event) => {
    setEmailId(event.target.value);
    sessionStorage.setItem('email', event.target.value);
    // setFieldValue('email', event.target.value);
  };

  const handleChangeOtp = (event) => {
    console.log('eventeventeventevent', event.target);
    setOtp(event.target.value);
    // setFieldValue('otp', event.target.value);
  };
  const tempLogin = () => {
    localStorage.setItem('loggedIn', true);
    history.push('/app/exams/examDashboard');
    handleSnackbarOpen('success', 'Login Success');
  };

  const onLoginData = () => {
    setActiveStep(1);
  };

  const logInProcess = async () => {
    let email = sessionStorage.getItem('email');
    if (KEY_USER.REGEX.EMAIL.test(email)) {
      try {
        setLoading(true);
        const res = await requestForOTP(email);
        if (!res || !res?.success) {
          console.log(res?.errorMessage);
          handleSnackbarOpen('error', res?.errorMessage);

          // values.setMessage({ type: 'error', text: res?.errorMessage });
        } else {
          setCheckOTP(true);
          setEmailData(res);
          // values.setMessage({ type: 'success', text: 'OTP sent to email' });
          // values.setMessage({ type: 'success', text: `OTP Is : ${res?.OTP}` });
          alert(`OTP is : ${res?.OTP}`);
          setActiveStep(1);
        }
      } catch (error) {
        // values.setMessage({ type: 'error', text: 'User not found' });
        console.log('error', error);
        handleSnackbarOpen('error', 'User is not admin');
      } finally {
        setLoading(false);
      }
    } else {
      // values.setMessage({ type: 'error', text: 'Invalid Email' });
      console.log('Invalid Email');
    }
  };
  const LoginVerify = async () => {
    let email = sessionStorage.getItem('email');
    if (KEY_USER.REGEX.NUMBER.test(otp)) {
      // console.log('values', values.otp);
      let payload = {
        otp: otp,
        id: email,
      };
      if (otp) {
        try {
          setLoading(true);
          const res = await verifyOTP(payload);
          if (!res || !res?.success) {
            console.log('OTP Invalid', res?.errorMessage);
            handleSnackbarOpen('error', res?.errorMessage);

            // values.setMessage({ type: 'error', text: res?.errorMessage });
          } else {
            localStorage.setItem('alumniName', res.alumniName);
            localStorage.setItem(
              KEY_LOGIN_ACCESS_TOKEN,
              res?.accessToken?.token
            );
            localStorage.setItem(
              'userDetails',
              JSON.stringify({
                alumniEmail: res?.alumniEmail,
                alumniId: res?.alumniId,
                alumniName: res?.alumniName,
              })
            );
            setVerifyData(res);
            localStorage.setItem('loggedIn', true);
            history.push('/app/exams/examDashboard');
            handleSnackbarOpen('success', 'Login Success');
            console.log('verified data', res);
          }
        } catch (error) {
          console.log(error);
          handleSnackbarOpen('error', 'OTP Invalid');

          // values.setMessage({ type: 'error', text: 'OTP Invalid' });
        } finally {
          setLoading(false);
        }
      }
    }
  };

  useEffect(() => {
    if (activeStep === 1) {
      let { seconds, minutes } = state;
      const myInterval = setInterval(() => {
        if (seconds > 0) {
          // setState(({ seconds }) => ({
          //     seconds: seconds - 1,
          // }));
          setState({ ...state, seconds: seconds - 1 });
        }
      }, 1000);
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval);
        } else {
          setState({ ...state, minutes: minutes - 1, seconds: 59 });
        }
      }
      return () => {
        clearInterval(myInterval);
      };
    } else {
      return;
    }
  }, [state, activeStep]);

  const authenticateUser = async () => {
    if (activeStep === 1) {
      LoginVerify();
    } else {
      logInProcess();
    }
  };

  const ResendOtp = () => {
    logInProcess();
    setState({
      seconds: 15,
      minutes: 0,
    });
  };

  return (
    <Grid
      container
      component="main"
      className={classes.root}
      data-testid="login-page"
    >
      <CssBaseline />

      <Grid item xs={12} sm={7} md={7} className={classes.image}>
        <Box className={classes.overlay}>
          <Grid>
            {config?.clientlogo === undefined ||
            config?.clientlogo === null ? null : (
              <Grid style={{ textAlign: 'center' }}>
                <img
                  alt="logo"
                  src={config?.clientlogo}
                  style={{ width: '100px', marginTop: '-48%' }}
                />
              </Grid>
            )}
            <Box>
              <Typography className={classes.fontStyleA}>
                {t('login:sideHeading1')}
              </Typography>
              <Typography className={classes.fontStyleA}>
                {t('login:sideHeading2')}
              </Typography>
            </Box>
          </Grid>
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        sm={5}
        md={5}
        container
        direction="column"
        justify="space-around"
        alignItems="center"
        elevation={6}
        className={classes.AbsolutePosition}
      >
        <Grid item className={classes.titleGrid}>
          <Typography
            className={classes.textFacultyPortal}
            data-testid="portal-title"
          >
            {t('login:portal')}
          </Typography>
        </Grid>
        {console.log('config', config)}
        <Grid
          item
          className={config?.logo ? classes.logoWrap : classes.signInWrap}
          data-testid="client-logo"
        >
          {/* {config?.logo === undefined || config?.logo === null ? null : (
            <img
              alt="logo"
              src={
                'https://inazstgpfs3001.blob.core.windows.net/assets/ken42_logo.png'
              }
              style={{ height: 100 }}
            />
          )} */}
          <KenIcon
            src={
              'https://inazstgpfs3001.blob.core.windows.net/assets/flame/images/FLAME-Logo.png'
            }
            iconType="img"
            // className={`${classes.kenIcon} ${classes.margin}`}
            variant="large"
            styles={{
              width: 'auto',
              height: 100,
              margin: '4px 8px',
            }}
          />
        </Grid>
        <Grid>
          <>
            <div className={classes.buttonDiv} data-testid="login-button">
              <div style={{ width: '310px' }}>
                {activeStep === 1 ? (
                  <>
                    {' '}
                    <Grid item xs={12} style={{ marginBottom: '20px' }}>
                      <KenInputField
                        placeholder={'Please enter the OTP'}
                        type="number"
                        required
                        label={t('labels:OTP')}
                        name="otp"
                        value={otp}
                        onChange={handleChangeOtp}
                      />
                    </Grid>{' '}
                    <Grid item xs={12}>
                      <KenButton
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={authenticateUser}
                      >
                        {' '}
                        {loading && <KenSmallLoader color={'#fff'} />}
                        {!loading && 'Verify & Sign in'}
                      </KenButton>{' '}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      container
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={2}
                    >
                      <Grid item xs={12}>
                        {state?.minutes === 0 && state?.seconds === 0 ? (
                          <Box
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                            }}
                          >
                            <KenButton
                              onClick={ResendOtp}
                              // disabled={
                              //   state?.minutes === 0 && state?.seconds === 0
                              //     ? false
                              //     : true
                              // }
                            >
                              Resend OTP
                            </KenButton>
                          </Box>
                        ) : (
                          <Typography align="center">
                            {state?.minutes}:
                            {state?.seconds < 10
                              ? `0${state?.seconds}`
                              : state?.seconds}
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  </>
                ) : (
                  <>
                    {' '}
                    <Grid item xs={12} style={{ marginBottom: '20px' }}>
                      <KenInputField
                        placeholder={'Please enter the Email ID.'}
                        required
                        label={t('labels:Email')}
                        name="Email"
                        value={emailId}
                        onChange={handleChangeEmail}
                        // errors={errors.otp}
                        // touched={touched.otp}
                      />
                    </Grid>{' '}
                    <Grid item xs={12}>
                      <KenButton
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        // className={classes.submit}
                        onClick={authenticateUser}
                      >
                        {loading && (
                          <KenSmallLoader color={'#fff'} />
                          // <CircularProgress size={14} color={'#fff'} />
                        )}
                        {!loading && '   Request OTP'}
                      </KenButton>{' '}
                    </Grid>
                  </>
                  // <Button
                  //   variant="contained"
                  //   color="primary"
                  //   className={clsx(classes.buttonDiv, {
                  //     [classes.hide]: progress,
                  //   })}
                  //   onClick={onLoginData}
                  //   // onClick={tempLogin} //renderProps.onClick
                  //   // disabled={renderProps.disabled}
                  // >
                  //   {t('login:Sign_Inss')}
                  // </Button>
                )}

                {/* {config?.google?.clientId && (
                  <GoogleLogin
                    clientId={config?.google?.clientId}
                    redirectUri={config?.google?.redirectUri}
                    render={(renderProps) => (
                      <Button
                        variant="contained"
                        color="primary"
                        className={clsx(classes.buttonDiv, {
                          [classes.hide]: progress,
                        })}
                        onClick={tempLogin} //renderProps.onClick
                        // disabled={renderProps.disabled}
                      >
                        {t('login:Sign_In')}
                      </Button>
                    )}
                    onSuccess={responseGoogle}
                    onFailure={responseGoogle}
                    cookiePolicy={config?.google?.cookiePolicy}
                  />
                )} */}
                {/* 
                <Button
                  variant="contained"
                  color="primary"
                  className={clsx(classes.buttonDiv, {
                    [classes.hide]: progress,
                  })}
                  // onClick={tempLogin} //renderProps.onClick
                  // disabled={renderProps.disabled}
                >
                  {t('login:Sign_In')}
                </Button> */}
              </div>
            </div>
            <div
              className={clsx(classes.buttonDiv, {
                [classes.hide]: !progress,
              })}
            ></div>
          </>
        </Grid>
        <Grid item className={classes.poweredByGrid}>
          <Box mb={2} textAlign="center">
            <Typography
              className={classes.powerBy}
              data-testid="powered-by-text"
            >
              {t('Powered_By')}
            </Typography>
            <Typography>
              {/* <img
                alt="logo"
                src={ken42Logo}
                className={classes.powerByImage}
                data-testid="powered-by-image"
              /> */}
            </Typography>
          </Box>
          <KenSnackBar
            message={snackbarMessage}
            severity={snackbarSeverity}
            autoHideDuration={4000}
            open={openSnackbar}
            handleSnackbarClose={handleSnackbarClose}
            position="Bottom-Right"
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default withRouter(LoginPage);
